import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import '../styles/MainView.css'
import '../styles/UserAccounts.css'
import logoutIcon from '../images/logout.png'
import key from '../images/key.png'
import Login from './Login'
import DropdownWidget from '../widgets/DropdownWidget'
import APIGenericRequest from '../api/APIGenericRequest'
import APIUserAccountRequest from '../api/APIUserAccountRequest'
import InputSearchWidget from '../widgets/InputSearchWidget'
import OverlayForm from '../widgets/OverlayForm'
import CreateUserForm from '../users/CreateUserForm'
import UserDetails from '../users/UserDetails'
import UpdateUserDetails from '../users/UpdateUserDetails'
import AlertMessage from '../widgets/AlertMessage'
import ActivityIndicator from '../widgets/ActivityIndicator'

class UserAccounts extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			user: JSON.parse(sessionStorage.getItem("user")),
			showInfoMessage: false,
			showWarningMessage: false,
			showConfirmMessage: false
		}
		this.handleSearchSubmit = this.handleSearchSubmit.bind(this)
		this.viewUserDetails = this.viewUserDetails.bind(this)
		this.getAllUsers = this.getAllUsers.bind(this)
		this.getUsersByRegionId = this.getUsersByRegionId.bind(this)
		this.closeOverlay = this.closeOverlay.bind(this)
		this.getAllUserByRoleId = this.getAllUserByRoleId.bind(this)
	}

	handleSearchSubmit(searchVal) {
		if(searchVal.province != null) {
			this.getUsersByProvinceId(searchVal.province.id, searchVal.role)
			this.setState({provinceId: searchVal.province.id, roleId: searchVal.role})
		}
		else if(searchVal.region != null) {
			this.getUsersByRegionId(searchVal.region.id, searchVal.role)
			this.setState({regionId: searchVal.region.id, roleId: searchVal.role})
		}
		else if(searchVal.role != null) {
			this.getAllUserByRoleId(searchVal.role)
			this.setState({roleId: searchVal.role})
		}
		else {
			this.setState({listData: null})
		}
	}

	createUser() {
		this.setState({
			overlayContent: <CreateUserForm onSignal={(message) => {
				if(this.state.regionId != null) {
					this.getUsersByRegionId(this.state.regionId, this.state.roleId)
				}
				else if(this.state.provinceId != null) {
					this.getUsersByProvinceId(this.state.provinceId, this.state.roleId)
				}
				this.closeOverlay()
			}} key="create-user" />,
			overlayHeight: "100%"
		})
	}

	viewUserDetails(id) {
		this.setState({
			overlayContent: <UserDetails userId={id} onSignal={(v, data, message) => {
				if(v === "update") {
					this.updateUserDetails(data)
				}
				else {
					this.closeOverlay()
				}
			}} key="user-details" />,
			overlayHeight: "100%"
		})
	}

	updateUserDetails(data) {
		this.setState({
			overlayContent: <UpdateUserDetails data={data} onSignal={(name, status) => {
				if(this.state.regionId != null) {
					this.getUsersByRegionId(this.state.regionId, this.state.roleId)
				}
				else if(this.state.provinceId != null) {
					this.getUsersByProvinceId(this.state.provinceId, this.state.roleId)
				}
				this.closeOverlay()
				if(status === "SUCCESS") {
					this.setState({
						showInfoMessage: true,
						aMessage: name.toUpperCase() + " details updated",
						closeForm: true,
						listData: []
					})
				}
				else {
					this.setState({
						showInfoMessage: true,
						aMessage: "Failed to update " + name + " details",
						closeForm: true,
						listData: []
					})
				}
			}} key="update-user-details" />,
			overlayHeight: "100%"
		})
	}

	closeOverlay() {
		this.setState({
			overlayContent: null,
			overlayHeight: "0%"
		})
	}

	getAllUsers(role) {
		const allUsers = APIUserAccountRequest.getAllUsers(this.state.accessToken)
		allUsers.then((response) => {
			let results = []
			if(response.status === "FAILED") {
				results = null
			}
			if(role != null) {
				for(const v of response.results.rows) {
					if(v.role === role.name) {
						results.push(v)
					}
				}
			}
			else {
				results = response.results.rows
			}
			this.setState({listData: results})
		})
	}

	getUsersByRegionId(id, role) {
		const allUsers = APIUserAccountRequest.getUsersByRegionId(this.state.accessToken, id)
		allUsers.then((response) => {
			let results = []
			if(response.status === "FAILED") {
				results = null
				role = null
			}
			if(role != null) {
				for(const v of response.results.rows) {
					if(v.role === role.name) {
						results.push(v)
					}
				}
			}
			else {
				results = response.results.rows
			}
			this.setState({listData: results})
		})
	}

	getUsersByProvinceId(id, role) {
		const allUsers = APIUserAccountRequest.getUsersByProvinceId(this.state.accessToken, id)
		allUsers.then((response) => {
			let results = []
			if(response.status === "FAILED") {
				results = null
				role = null
			}
			if(role != null) {
				for(const v of response.results.rows) {
					if(v.role === role.name) {
						results.push(v)
					}
				}
			}
			else {
				results = response.results.rows
			}
			this.setState({listData: results})
		})
	}

	getAllUserByRoleId(role) {
		const allUsers = APIUserAccountRequest.getAllUsersByRoleId(this.state.accessToken, role.id)
		allUsers.then((response) => {
			let results = []
			if(response.status === "FAILED") {
				results = null
				role = null
			}
			if(role != null) {
				for(const v of response.results.rows) {
					if(v.role === role.name) {
						results.push(v)
					}
				}
			}
			else {
				results = response.results.rows
			}
			this.setState({listData: results})
		})
	}
	render() {
		const content = <div className="container-widget">
			<div className="container-header" style={{'justify-content': "center"}}>
				<div className="container-title"><div>USER ACCOUNTS</div></div>
			</div>
			<div id="container-body">{<UsersListView data={this.state.listData}
				createUser={() => { this.createUser() }}
				viewDetails={this.viewUserDetails} />}</div>
		</div>
		return(<div id="main-view">
			<Header user={this.state.user} />
			<div id="ua-title">USER ACCOUNTS</div>
			<Sidebar searchSubmit={this.handleSearchSubmit} />
			<div id="content-pane">{content}</div>
			<OverlayForm content={this.state.overlayContent} cHeight={this.state.overlayHeight} top='10%' left='50%' />
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => { this.setState({showInfoMessage: false}) }} />}
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>)
	}
}

function Header(props) {
	return (<div id="header">
		<div id="title">LINKSFARMM MELA</div>
		<div id="account-name">
			<div id="role">{props.user.role}</div>
			<ul><li class="drop">
				<button>{props.user.first_name} {props.user.middle_name} {props.user.last_name} {props.user.extension_name}</button>
				<div class="dropdown">
					<div class="dropout">
						<ul>
							<li id="change-pw" onClick={() => {
								console.log("CHANGE PASSWORD")
							}}><span>
								<img src={key} />
								<label>CHANGE PASSWORD</label>
							</span></li>
							<li id="logout" onClick={() => {
								ReactDOM.render(<Login />, document.getElementById("app"))
							}}><span>
								<img src={logoutIcon} />
								<label>LOGOUT</label>
							</span></li>
						</ul>
					</div>
				</div>
			</li></ul>
		</div>
	</div>)
}

class Sidebar extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			region: "-- SELECT --",
			province: "-- ANY --",
			role: "-- ANY --",
		}
		this.getAllRegions = this.getAllRegions.bind(this)
		this.getAllProvincesByRegionId = this.getAllProvincesByRegionId.bind(this)
		this.getAllUserRoles = this.getAllUserRoles.bind(this)
	}

	componentWillMount() {
		this.getAllRegions()
		this.getAllUserRoles()
	}

	getAllRegions() {
		const region = APIGenericRequest.getAllRegions(this.state.accessToken)
		region.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push(v.name.split("[")[0])
				var rows = response.results.rows
			}
			c.sort()
			const regions = []
			regions.push({id: 0, name: "-- ANY --"})
			for(const re of c) {
				for(const ro of rows) {
					if(ro.name.includes(re)) {
						regions.push({id: ro.region_id, name: ro.name.split("[")[0]})
						const index = rows.indexOf(ro)
						rows.splice(index, 1)
					}
				}
			}
			this.setState({regions: regions, province: "-- ANY --"})
		})
	}

	getAllProvincesByRegionId(id) {
		const province = APIGenericRequest.getAllProvincesByRegionId(this.state.accessToken, id)
		province.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push(v.name.split("[")[0])
				var rows = response.results.rows
			}
			c.sort()
			const provinces = []
			provinces.push({id: 0, name: "-- ANY --"})
			for(const re of c) {
				for(const ro of rows) {
					if(ro.name.includes(re)) {
						provinces.push({id: ro.province_id, name: ro.name.split("[")[0]})
						const index = rows.indexOf(ro)
						rows.splice(index, 1)
					}
				}
			}
			this.setState({provinces: provinces, province: "-- ANY --", provinceVal: null})
		})
	}

	getAllUserRoles() {
		const province = APIUserAccountRequest.getAllUserRoles(this.state.accessToken)
		province.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push(v.name.split("[")[0])
				var rows = response.results.rows
			}
			c.sort()
			const roles = []
			roles.push({id: 0, name: "-- ANY --"})
			for(const re of c) {
				for(const ro of rows) {
					if(ro.name.includes(re)) {
						roles.push({id: ro.role_id, name: ro.name})
						const index = rows.indexOf(ro)
						rows.splice(index, 1)
					}
				}
			}
			this.setState({roles: roles})
		})
	}

	render() {
		const view = <div id="ua-sidebar">
			<div>SEARCH BY</div>
			<div id="ua-region">
				<div>Region</div>
				<DropdownWidget list={this.state.regions} placeholder={this.state.region}
					cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
						let regionVal = {id: id, name: val}
						if(id === "0") {
							regionVal = null
						}
						this.setState({
							regionVal: regionVal,
							region: val
						})
						this.getAllProvincesByRegionId(id)
					}}
				key="region" />
			</div>
			<div id="ua-province">
				<div>Province</div>
				<DropdownWidget list={this.state.provinces} placeholder={this.state.province}
					cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
						let provinceVal = {id: id, name: val}
						if(id === "0") {
							provinceVal = null
						}
						this.setState({
							provinceVal: provinceVal,
							province: val
						})
					}}
				key="province" />
			</div>
			<div id="ua-role">
				<div>Role</div>
				<DropdownWidget list={this.state.roles} placeholder={this.state.role}
					cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
						let roleVal = {id: id, name: val}
						if(id === "0") {
							roleVal = null
						}
						this.setState({
							roleVal: roleVal,
							role: val
						})
					}}
				key="role" />
			</div>
			<div id="ua-search-btn">
				<button className="green-two" onClick={(e) => {
					this.props.searchSubmit({
						region: this.state.regionVal,
						province: this.state.provinceVal,
						role: this.state.roleVal
					})
				}}>SEARCH</button>
			</div>
			<div id="ua-search-btn">
				<button className="green-two" onClick={(e) => {
					this.props.searchSubmit({
						region: null,
						province: null,
						role: null
					})
					this.setState({
						region: "-- SELECT --",
						province: "-- ANY --",
						role: "-- ANY --",
					})
				}}>CLEAR</button>
			</div>
			<Clock />
		</div>
		return(view)
	}
}

class UsersListView extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			searchLabel: (props.data != null)? props.data.length + " result(s)": "PRESS THE SEARCH BUTTON TO SEE RESULTS",
			listItems: [],
			count: 0,
			placeholder: "SEARCH NAME"
		}
	}

	componentDidUpdate(prevProps) {
		if(prevProps.data != this.props.data) {
			if(this.props.data == null) {
				this.setState({
					searchLabel:  (this.props.data != null)? "0 RESULT": "PRESS THE SEARCH BUTTON TO SEE RESULTS",
					listItems: [],
					placeholder: "SEARCH NAME"
				})
				return
			}
			const listItems = []
			for(const v of this.props.data) {
				listItems.push(<ListItem data={v} viewDetails={(id) => {
					this.props.viewDetails(id)
				}} key={"li" + this.state.count++} />)
			}
			this.setState({
				searchLabel:  (this.props.data != null)? this.props.data.length + " RESULT(S)": "PRESS THE SEARCH BUTTON TO SEE RESULTS",
				listItems: listItems,
				placeholder: "SEARCH NAME"
			})
		}
	}

	render() {
		return(<div className="farmers-lv">
			<div className="flv-top">
				<InputSearchWidget placeholder={this.state.placeholder} cStyle={{'width': '385px'}}
					onSearchClick={(value) => {
						if(this.props.data == null) {
							return
						}
						const sr = searchString(value, this.props.data, "name")
						if(sr == null) {
							return
						}
						const listItems = []
						for(const v of sr) {
							listItems.push(<ListItem data={v} viewDetails={this.viewDetails} key={"li" + this.state.count++} />)
						}
						this.setState({
							searchLabel:  sr.length + " RESULT(S)",
							listItems: listItems
						})
					}}
					onEnterPress={(value) => {
						if(this.props.data == null) {
							return
						}
						const sr = searchString(value, this.props.data, "name")
						if(sr == null) {
							return
						}
						const listItems = []
						for(const v of sr) {
							listItems.push(<ListItem data={v} viewDetails={this.viewDetails} key={"li" + this.state.count++} />)
						}
						this.setState({
							searchLabel:  sr.length + " RESULT(S)",
							listItems: listItems
						})
					}} />
				<div className="flv-label"><div>{this.state.searchLabel}</div></div>
			</div>
			<div className="flv-header">
				<table className="flv-table-header">
					<col style={{width: '20%'}} />
					<col style={{width: '20%'}} />
					<col style={{width: '20%'}} />
					<col style={{width: '20%'}} />
					<col style={{width: '20%'}} />
					<tr>
						<th>FULL NAME</th>
						<th>ROLE</th>
						<th>CONTACT NO.</th>
						<th>PROVINCE</th>
						<th>REGION</th>
						<div className="flv-grid-btn"><button className="green-two" onClick={(e) => {
								this.props.createUser("hello")
							}}>CREATE USER</button>
						</div>
					</tr>
				</table>
			</div>
			<div className="flv-items">{this.state.listItems}</div>
			{this.state.listItems.length < 1 && <div className="flv-result"><div>NO RESULT</div></div>}
		</div>)
	}
}

class ListItem extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
		}
	}

	componentWillMount() {
		const region = APIGenericRequest.getRegionById(this.state.accessToken, this.props.data.region_id)
		region.then((rc) => {
			this.setState({region: rc.results.name})
		})
		const province = APIGenericRequest.getProvinceById(this.state.accessToken, this.props.data.province_id)
		province.then((rc) => {
			this.setState({province: rc.results.name})
		})
		const role = APIUserAccountRequest.getUserRoleById(this.state.accessToken, this.props.data.role_id)
		role.then((rc) => {
			this.setState({role: rc.results.name})
		})
	}

	render() {
		let middleInitial = ""
		if(this.props.data.middle_name != null) {
			middleInitial = this.props.data.middle_name.charAt(0) + "."
		}
		const extName = (this.props.data.extension_name == null)? "": this.props.data.extension_name
		const name = this.props.data.first_name + " " + middleInitial + " " + this.props.data.last_name + " " + extName
		const view = <div className="fc-list-item">
			<table className="fc-table-data">
				<col style={{width: '20%'}} />
				<col style={{width: '20%'}} />
				<col style={{width: '20%'}} />
				<col style={{width: '20%'}} />
				<col style={{width: '20%'}} />
				<tr>
					<td>{name.toUpperCase()}</td>
					<td>{this.state.role}</td>
					<td>{this.props.data.contact_no}</td>
					<td>{this.state.province}</td>
					<td>{this.state.region}</td>
					<div className="flv-grid-btn"><button className="btn-view-details" onClick={(e) => {
							this.props.viewDetails(this.props.data.employee_id)
						}}>VIEW DETAILS</button>
					</div>
				</tr>
			</table>
		</div>
		return(view)
	}
}

class Clock extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			date: setTimeZone(8)
		}
	}

	componentDidMount() {
		const cMonth = this.state.date.getMonth() + 1
		const cDay = this.state.date.getDate()
		const cYear = this.state.date.getFullYear()
		const cDate = cMonth + "/" + cDay + "/" + cYear
		this.setState({cDate: cDate})
		this.timerID = setInterval(() => this.tick(), 1000)
	}

	componentWillUnmount() {
		clearInterval(this.timerID)
	}

	tick() {
		const date = new Date(this.state.date.setSeconds(this.state.date.getSeconds() + 1))
		this.setState({date: date})
	}

	render() {
		return(
			<div id="clock">
				<div id="clock-date">{this.state.cDate}</div>
				<div id="clock-time">{this.state.date.toLocaleTimeString()}</div>
			</div>
		)
	}
}

const searchString = (str, data, field) => {
	if(data.length < 1) {
		return
	}
	if(str == null) {
		str = ""
	}
	const ss = str.toLowerCase()
	const list = []
	for(const v of data) {
		const name = v.first_name + " " + v.middle_name + " " + v.last_name + " " + v.extension_name
		if(name.toLowerCase().includes(ss)) {
			list.push(v)
		}
		if(v.contact_no != null) {
			if(v.contact_no.toLowerCase().includes(ss)) {
				list.push(v)
			}
		}
	}
	return(list)
}

const setTimeZone = (offset) => {
	const date = new Date()
	const localeOffset = date.getTimezoneOffset() * 60000
	const utc = date.getTime() + localeOffset
	const nLocale = utc + (3600000 * offset)
	return(new Date(nLocale))
}

export default UserAccounts
